module.exports = __webpack_public_path__ + "static/media/Balloon.d028cce0.glb";